export default __webpack_public_path__ + "static/media/iconEstrela.452368ce.svg";